import type { TFunction } from 'i18next';
import { readBackendErrorCode } from '@/api/readBackendErrorCode';
import { resolveApiErrorTranslationKey } from '@/api/resolveApiErrorTranslationKey';

export function translateBackendError(t: TFunction, caughtError: unknown): string {
  const backendErrorCode = readBackendErrorCode(caughtError);
  if (backendErrorCode.length > 0) {
    const translatedByCode = t('errors:byCode.' + backendErrorCode, { defaultValue: '' });
    if (translatedByCode.length > 0) {
      return translatedByCode;
    }
  }
  return t(resolveApiErrorTranslationKey(caughtError));
}
